import { NgModule } from '@angular/core';
import { FilterDestroyedPipe } from './filter-destroyed';

@NgModule({
  providers: [FilterDestroyedPipe],
  declarations: [FilterDestroyedPipe],
  exports: [FilterDestroyedPipe],
})
export class FilterDestroyedPipeModule {}
